import { useTranslation } from "react-i18next"

import { EmptyState } from "@/components/empty-state"
import { PageHeader } from "@/components/page-header"
import { ActiveUsinages } from "@/features/dashboard/components/active-usinages"
import { ContractFocus } from "@/features/dashboard/components/contract-focus"
import { DashboardSkeleton } from "@/features/dashboard/components/dashboard-skeleton"
import { PipelineStrip } from "@/features/dashboard/components/pipeline-strip"
import { RecentLoads } from "@/features/dashboard/components/recent-loads"
import { useDashboardSummary } from "@/features/dashboard/hooks/use-dashboard"

export function DashboardPage() {
  const { t } = useTranslation("dashboard")
  const { data, isLoading, isError, refetch } = useDashboardSummary()

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title={t("title")} description={t("subtitle")} />

      {isLoading ? (
        <DashboardSkeleton />
      ) : isError || !data ? (
        <EmptyState
          title={t("error.title")}
          description={t("error.description")}
          action={
            <button
              type="button"
              onClick={() => refetch()}
              className="text-primary text-sm font-medium hover:underline"
            >
              {t("error.retry")}
            </button>
          }
        />
      ) : (
        <>
          <PipelineStrip pipeline={data.pipeline} />
          <div className="grid items-start gap-4 lg:grid-cols-2">
            <div className="flex flex-col gap-4">
              <ContractFocus contracts={data.contracts} />
            </div>
            <div className="flex flex-col gap-4">
              <ActiveUsinages usinages={data.activeUsinages} />
              <RecentLoads loads={data.recentLoads} />
            </div>
          </div>
        </>
      )}
    </div>
  )
}
